import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Zap } from 'lucide-react';

const TEMPLATES = [
  {
    id: 'classic-blue',
    name: 'Classic Blue',
    preview: 'from-blue-600 to-blue-800',
    json: {
      version: '5.3.0',
      objects: [
        { type: 'rect', version: '5.3.0', left: 0, top: 0, width: 600, height: 200, fill: '#1e40af', selectable: false, evented: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 36, text: 'John Smith', fontSize: 28, fill: '#ffffff', fontWeight: 'bold', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 78, text: 'Senior Developer · Company Inc.', fontSize: 14, fill: '#93c5fd', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 106, text: '(555) 123-4567  |  john@company.com', fontSize: 12, fill: '#bfdbfe', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 130, text: 'company.com', fontSize: 12, fill: '#93c5fd', fontFamily: 'Arial' },
      ],
      background: '#1e40af',
    },
  },
  {
    id: 'minimal-white',
    name: 'Minimal White',
    preview: 'from-white to-gray-50',
    json: {
      version: '5.3.0',
      objects: [
        { type: 'rect', version: '5.3.0', left: 0, top: 0, width: 5, height: 200, fill: '#3b82f6', selectable: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 36, text: 'Jane Doe', fontSize: 26, fill: '#111827', fontWeight: 'bold', fontFamily: 'Georgia, serif' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 76, text: 'Marketing Director', fontSize: 14, fill: '#6b7280', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 106, text: '(555) 987-6543', fontSize: 12, fill: '#374151', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 126, text: 'jane@company.com', fontSize: 12, fill: '#2563eb', fontFamily: 'Arial' },
      ],
      background: '#ffffff',
    },
  },
  {
    id: 'dark-modern',
    name: 'Dark Modern',
    preview: 'from-gray-900 to-gray-800',
    json: {
      version: '5.3.0',
      objects: [
        { type: 'rect', version: '5.3.0', left: 0, top: 0, width: 600, height: 200, fill: '#111827', selectable: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 30, text: 'Alex Johnson', fontSize: 26, fill: '#f9fafb', fontWeight: 'bold', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 68, text: 'CEO & Founder', fontSize: 14, fill: '#9ca3af', fontFamily: 'Arial' },
        { type: 'rect', version: '5.3.0', left: 24, top: 96, width: 60, height: 3, fill: '#8b5cf6', selectable: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 112, text: 'alex@startup.io  |  startup.io', fontSize: 12, fill: '#c4b5fd', fontFamily: 'Arial' },
      ],
      background: '#111827',
    },
  },
  {
    id: 'gradient-creative',
    name: 'Gradient Creative',
    preview: 'from-purple-500 to-pink-500',
    json: {
      version: '5.3.0',
      objects: [
        { type: 'i-text', version: '5.3.0', left: 24, top: 26, text: 'Sam Rivera', fontSize: 32, fill: '#7c3aed', fontWeight: 'bold', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 74, text: 'Creative Designer & Strategist', fontSize: 15, fill: '#ec4899', fontFamily: 'Arial' },
        { type: 'rect', version: '5.3.0', left: 24, top: 106, width: 300, height: 2, fill: '#e879f9', selectable: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 118, text: 'sam@studio.design  |  @samrivera', fontSize: 12, fill: '#6b7280', fontFamily: 'Arial' },
      ],
      background: '#fdf4ff',
    },
  },
  {
    id: 'green-nature',
    name: 'Green Nature',
    preview: 'from-green-600 to-emerald-700',
    json: {
      version: '5.3.0',
      objects: [
        { type: 'rect', version: '5.3.0', left: 0, top: 0, width: 600, height: 200, fill: '#065f46', selectable: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 36, text: 'Morgan Green', fontSize: 26, fill: '#ecfdf5', fontWeight: 'bold', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 76, text: 'Environmental Consultant', fontSize: 14, fill: '#6ee7b7', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 108, text: 'morgan@ecogroup.org  |  (555) 246-8135', fontSize: 12, fill: '#a7f3d0', fontFamily: 'Arial' },
      ],
      background: '#065f46',
    },
  },
  {
    id: 'orange-bold',
    name: 'Orange Bold',
    preview: 'from-orange-500 to-red-500',
    json: {
      version: '5.3.0',
      objects: [
        { type: 'rect', version: '5.3.0', left: 0, top: 160, width: 600, height: 40, fill: '#ea580c', selectable: false },
        { type: 'i-text', version: '5.3.0', left: 24, top: 24, text: 'Chris Thompson', fontSize: 28, fill: '#1a1a1a', fontWeight: 'bold', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 68, text: 'Sales Director', fontSize: 15, fill: '#374151', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 96, text: 'chris@salesteam.com', fontSize: 12, fill: '#ea580c', fontFamily: 'Arial' },
        { type: 'i-text', version: '5.3.0', left: 24, top: 168, text: '(555) 369-2580  |  salesteam.com', fontSize: 11, fill: '#ffffff', fontFamily: 'Arial' },
      ],
      background: '#ffffff',
    },
  },
];

export default function Templates() {
  const navigate = useNavigate();

  const applyTemplate = (template) => {
    sessionStorage.setItem('templateJSON', JSON.stringify(template.json));
    navigate('/email-signatures');
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1 text-gray-500 hover:text-gray-700 mb-6 text-sm"
      >
        <ArrowLeft className="w-4 h-4" /> Back to Builder
      </button>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Email Signature Templates</h1>
      <p className="text-gray-500 mb-8">
        Choose a template to get started. You can customize everything in the builder.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {TEMPLATES.map(t => (
          <div key={t.id} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div className={`h-28 bg-gradient-to-r ${t.preview} flex items-center justify-center`}>
              <span className="text-white/70 text-xs font-medium">{t.name}</span>
            </div>
            <div className="p-4 flex items-center justify-between">
              <span className="font-medium text-gray-800 text-sm">{t.name}</span>
              <button
                onClick={() => applyTemplate(t)}
                className="flex items-center gap-1 bg-blue-600 text-white px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-blue-700"
              >
                <Zap className="w-3 h-3" /> Use
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
